<div class="user-monthly-usage-container">
    <h3 class="user-monthly-usage-title">{{'user_billing.monthly_influencer_usage.header' | translate}}</h3>
    
    <div class="user-monthly-usage-legend">
        <span>{{'user_billing.monthly_influencer_usage.sub_title' | translate}}</span>
        <b *ngIf="!userMonthlyUsage.isLoading" class="highlight-value mx-1">
            <ng-container *ngIf="!userMonthlyUsage.isLoadingError">{{userMonthlyUsage.accountLevelsCustomUsage?.monthlyActiveInfluencers}}</ng-container>
            <ng-container *ngIf="userMonthlyUsage.isLoadingError">-</ng-container>
        </b> 
        <achoo-loader *ngIf="userMonthlyUsage.isLoading" [textPlaceholder]="true"></achoo-loader>
        <span>{{'user_billing.monthly_influencer_usage.active_influencers' | translate}}</span>
    </div>

    <div class="user-monthly-usage-table">
        <div class="user-monthly-usage-row header">
            <div class="cell">{{'user_billing.monthly_influencer_usage.column_header.term' | translate}}</div>
            <div class="cell">{{'user_billing.monthly_influencer_usage.column_header.activated_influencers' | translate}}</div>
        </div>

        <div *ngIf="!userMonthlyUsage.isLoading && !userMonthlyUsage.isLoadingError" class="user-monthly-usage-table-body">
            <div *ngFor="let usage of userMonthlyUsage.monthlyUsage" class="user-monthly-usage-row value">
                <div class="cell">{{usage.termStart | date: 'dd/MM/yyyy'}}</div>
                <div *ngIf="usage.activeInfluencers === null" class="cell">-</div>
                <div *ngIf="usage.activeInfluencers !== null" class="cell">{{usage.activeInfluencers}}</div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/main/user/user-billing/user-monthly-usage/user-monthly-usage.component.html